import Extern from '@lib/layouts/Extern/Main.vue';
import Login from '@lib/pages/Extern/Login.vue';

// Default routes
const children = [
	{ path: 'login', name: 'Login', component: Login },
	{ path: 'verify-email', name: 'VerifyEmail', component: () => import('@lib/pages/Extern/VerifyEmail.vue') },
	{ path: 'forgot-password', name: 'ForgotPassword', component: () => import('@lib/pages/Extern/PasswordReset.vue') },
	{ path: 'reset-password', name: 'ResetPassword', component: () => import('@lib/pages/Extern/NewPassword.vue') },
	{ path: '/privacy', component: () => import('@lib/pages/Extern/Privacy.vue') },
	{ path: '/legal', component: () => import('@lib/pages/Extern/Legal.vue') },
	{ path: '/disclosure', component: () => import('@lib/pages/Extern/Disclosure.vue') },
];

// Optional routes dependend on featuere flags
if (globalThis.env?.app?.self_registration === true) {
	children.push({
		path: 'register',
		name: 'Register',
		component: () => import('@lib/pages/Extern/Register.vue'),
	});
}

export default [
	{
		path: '/',
		redirect: '/login',
		component: Extern,
		meta: { auth: false, requiresAuth: false },
		children,
	},
];
